module.exports = __webpack_public_path__ + "img/rafako_logo.9d5fcca7.png";